.m-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1-5);
  padding: var(--space-1) var(--space-3);
  background: var(--stat-chip-bg);
  border: 1px solid var(--stat-chip-border);
  border-radius: var(--radius-pill);
  color: var(--stat-chip-text);
  font-family: Arial, sans-serif;
  font-size: var(--font-size-sm);
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;

  &__dot {
    flex-shrink: 0;
    width: 9px;
    height: 9px;
    border-radius: var(--radius-circle);
  }

  &__label {
    // intentionally unstyled — inherits chip font
  }

  &__value {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  &--interactive {
    // Reset button defaults
    appearance: none;
    cursor: pointer;
    border: 1px solid var(--stat-chip-border);

    &:hover {
      background: var(--hover-background);
    }

    &:focus-visible {
      outline: 3px solid var(--stat-chip-focus-ring);
      outline-offset: 2px;
    }

    &:active {
      background: var(--hover-background);
    }
  }

  &--selected {
    background: var(--stat-chip-selected-bg);
    color: var(--stat-chip-selected-text);
    border-color: var(--stat-chip-selected-bg);

    // Override the generic light-grey hover so white text stays legible (WCAG 4.5:1)
    &:hover {
      background: var(--stat-chip-selected-hover-bg);
      border-color: var(--stat-chip-selected-hover-bg);
    }

    &:active {
      background: var(--stat-chip-selected-hover-bg);
      border-color: var(--stat-chip-selected-hover-bg);
    }
  }
}
